import styled from "styled-components";

export const GreenText = styled.span`
  color: #01C716;
`

export const SubTitle = styled.div`
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;
  text-align: center;
  margin: 16px 0 56px;
  
  @media (min-width: 980px) {
    font-size: 22px;
    margin: 12px 0 40px;
  }
`

export const FeedbackWrapper = styled.div`
  margin-top: 40px;
`